import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import DynamicComponentError from "%/errors/dynamic-component-error";

export default class StoryCardClickBehavior extends BaseOption {
  displayOverrideIcon = false;

  static optionValues = {
    authorProfile: "authorProfile",
    postPage: "postPage",
    notALink: "notALink",
  };

  static label = "Click Behavior";
  static userInterfaceComponent = {
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Author Profile",
          value: "authorProfile",
          tooltip: "",
        },
        {
          label: "Story Page",
          value: "postPage",
          tooltip: "",
        },
        {
          label: "Not a Link",
          value: "notALink",
          tooltip: "",
        },
      ],
    },
  };

  static storyHref(baseUrl, idMapping, optionValue) {
    switch (optionValue) {
      case this.optionValues.authorProfile:
        return `${baseUrl}/user-profile/${idMapping.authorProfile}`;
      case this.optionValues.postPage:
        // Canonical story page for every story type — a nested type-specific
        // path (program day/week/…) is not the "Story Page" link.
        return `${baseUrl}/story/${idMapping.postPage}`;
      case this.optionValues.notALink:
        return null;
      default:
        throw new DynamicComponentError(
          `Unknown story-card click behavior ${JSON.stringify(optionValue)}; expected one of `
            + `${Object.values(this.optionValues).join(", ")}. An undefined value means the element's `
            + "compiled defaults carry no story-card-click-behavior.",
          { optionValue },
        );
    }
  }

  static defaultValue = "postPage";
}
